// P2b tanda 2 — ayudantes del formulario de producto (generación de SKU,
// existencia de SKU). Funciones puras, sin red. Tanda 4c: la plantilla por tipo
// vive en la configuración sembrada (utils/tiposProducto.js); nada acá asume la
// tienda ni sus tipos.

import { TIPOS_PRODUCTO_DEFAULT, tipoActivo } from './tiposProducto';

// Normaliza a tokens aptos para SKU (solo A-Z0-9, sin tildes ni espacios).
function tokens(name) {
  return String(name || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, ' ')
    .split(/\s+/).filter(Boolean);
}

// Item 7 + tanda 4c: tipo CON marca obligatoria → MARCA-PRODUCTO desde el
// nombre; tipo SIN marca → PREFIJO-NOMBRE con el prefijo de marca propia
// CONFIGURADO (o derivado del nombre de la tienda); sin prefijo, solo el nombre.
export function generateSku(form, { tipos = TIPOS_PRODUCTO_DEFAULT, prefijoPropio = '' } = {}) {
  const f = form || {};
  const t = tokens(f.name);
  if (!t.length) return '';
  const tipo = tipoActivo(tipos, f.productKind);
  if (tipo && tipo.marcaObligatoria) {
    const marca = t[0].slice(0, 4);
    const producto = (t.slice(1).join('') || t[0]).slice(0, 10);
    return `${marca}-${producto || 'PROD'}`;
  }
  const pre = String(prefijoPropio || '').trim().toUpperCase();
  return pre ? `${pre}-${t.join('-')}` : t.join('-');
}

// Item 2: los campos numéricos del padre variable muestran SOLO números.
// Rango de precios de las variaciones: "80000 – 95000", "80000" si es único, "" si no hay.
export function rangoPrecioVariaciones(variations = []) {
  const precios = variations.map((v) => parseInt(v.regular_price, 10)).filter((n) => n > 0);
  if (!precios.length) return '';
  const min = Math.min(...precios); const max = Math.max(...precios);
  return min === max ? String(min) : `${min} – ${max}`;
}

export function totalStockVariaciones(variations = []) {
  return variations.reduce((s, v) => s + (v.stock_quantity || 0), 0);
}

// Estado de WooCommerce legible (para el subtítulo de edición).
export function estadoWooLabel(status) {
  const map = { publish: 'Publicado', draft: 'Borrador', private: 'Privado', pending: 'Pendiente', future: 'Programada' };
  return map[status] || status || '';
}

export function skuExistsInCatalog(sku, existingSkus = []) {
  const s = String(sku || '').trim().toUpperCase();
  if (!s) return false;
  return existingSkus.some((x) => String(x || '').trim().toUpperCase() === s);
}
